export const trackError = (name: string, message: string, cause?: Error) => {
  const err = new Error(message);
  err.name = name;
  err.cause = cause;

  //@ts-ignore
  window?.DD_RUM?.addError(err);
};
